// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7acc060e","455":"319cca5e"}[chunkId] + ".chunk.js";
};